/**
 * Check if children of selected range contains any formatting
 * - loop through children & recuse till we return the first child
 * that has formatting
 *
 * @param {NodeList} children - list of child nodes in the selected range
 * @param {String} nodeName - of the format we are looking for
 * @param {String} format - name of the format we are looking for (as set it data-format attribute)
 * @returns {Node} node of nodeName type && has attrubute dataset.format === format
 * or null if children do not contain any formatting
 *
 */
const checkIfFormatted = (children, nodeName, format) => {
  let result = null;
  for (let child of children) {
    if (child.nodeName === nodeName && child.dataset.format === format) {
      result = child;
      break;
    } else if (child.children && child.children.length > 0) {
      result = checkIfFormatted(child.children);
      break;
    }
  }
  return result;
};

/**
 * If selected range has formatting, undo it
 * - go through nodes of the Ragne's doc fragment to check for formatted nodes
 *
 * @param {Range} range - selcted text
 * @param {Object} formatDetails - meta data for format we want to undo
 * @returns {Boolean}
 */
export default (range, formatDetails) => {
  let undoSuccessful = false;
  let docFragment = range.cloneContents();
  if (docFragment.childNodes.length > 0) {
    let isFormatted = checkIfFormatted(
      docFragment.childNodes,
      formatDetails.nodeName,
      formatDetails.attribute,
    );
    /** selected text is at the start or end or a sentence or nested within other formatted nodes **/
    if (isFormatted) {
      const textNode = document.createTextNode(range.toString());
      // replace Range with plain text node
      range.deleteContents();
      range.insertNode(textNode);
      range.selectNodeContents(textNode);
      undoSuccessful = true;
    } else if (
      /** selected text is in the middle of a sentence **/
      range.startContainer.parentElement.nodeName === formatDetails.nodeName &&
      range.startContainer.parentElement.dataset.format === formatDetails.attribute
    ) {
      // break Range up into boundaries and selected text
      const startText = range.startContainer.textContent.slice(0, range.startOffset);
      const endText = range.startContainer.textContent.slice(range.endOffset);
      const selectedText = range.startContainer.textContent.slice(
        range.startOffset,
        range.endOffset,
      );
      // format boundary nodes & create plain text node for selected text
      const startNode = formatDetails.createNode(startText);
      const selectedNode = document.createTextNode(selectedText);
      const endNode = formatDetails.createNode(endText);
      // replace the parent container with new nodes
      range.startContainer.parentNode.replaceWith(startNode, selectedNode, endNode);

      undoSuccessful = true;
    }
  }
  return undoSuccessful;
};
